/** MF 子应用授权只使用稳定业务身份；菜单域和路由别名不得作为授权 ID。 */
export const MF_APPLICATION_IDS = ['crm', 'operations', 'agent'];
export const ACCESS_REASON_CODES = [
    'APP_NOT_ASSIGNED',
    'TOKEN_AUDIENCE_MISMATCH',
    'TENANT_MISMATCH',
    'ROLE_NOT_ASSIGNED',
    'ROLE_PROJECTION_PENDING',
    'PRIVILEGE_DENIED',
    'RELEASE_NOT_READY',
];
